
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SimilarProfilesResponse,
} from '../models';
import {
    SimilarProfilesResponseFromJSON,
    SimilarProfilesResponseToJSON,
} from '../models';

export interface GetSimilarProfilesRequest {
    profileId: string;
}

/**
 * 
 */
export class PublicSimilarProfilesApi extends runtime.BaseAPI {

    /**
          */
    async getSimilarProfilesRaw(requestParameters: GetSimilarProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SimilarProfilesResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getSimilarProfiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SimilarProfilesResponse>({
            path: `/profile/public-api/{profileId}/similars`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SimilarProfilesResponseFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getSimilarProfiles(requestParameters: GetSimilarProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SimilarProfilesResponse> {
        const response = await this.getSimilarProfilesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
